var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9114_37536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H22V22H1V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9114_37536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9811 17.7675C14.6898 18.5497 13.175 19 11.555 19C6.83025 19 3 15.1698 3 10.445C3 5.72017 6.83025 1.89 11.555 1.89C16.2798 1.89 20.11 5.72017 20.11 10.445C20.11 12.2019 19.5683 13.8351 18.66 15.1937",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1106 13.2465L14.4426 11.3161C14.9358 11.0304 14.9358 10.3167 14.4426 10.031L11.1106 8.10062C10.6171 7.81474 10 8.17177 10 8.74315V12.6039C10 13.1754 10.6171 13.5324 11.1106 13.2465Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a5401c88b672cc30e16285b82c2b4fac.svg";
export { ForwardRef as ReactComponent };